import { render, staticRenderFns } from "./BusinessMemberHistoryDisputeEvent.vue?vue&type=template&id=81ce2002"
import script from "./BusinessMemberHistoryDisputeEvent.vue?vue&type=script&lang=js"
export * from "./BusinessMemberHistoryDisputeEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports